/**
 * Approvals API helpers
 */

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Helper to get admin token (for MVP)
const getAdminToken = () => 'dev';

/**
 * Fetch pending Slack approvals
 */
export async function fetchPendingApprovals(brandId, limit = 200) {
  const res = await fetch(
    `${API_BASE}/api/v1/integrations/slack/pending-approvals?brand_id=${encodeURIComponent(brandId)}&limit=${limit}`,
    {
      headers: {
        'X-Admin-Token': getAdminToken()
      }
    }
  );
  
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to fetch pending approvals');
  }
  
  return res.json();
}
